export const ConstStatic = {
  TOKEN_KEY: 'TSGC_TOKEN',
  USER_INFO: 'TSGC_USERINFO',
  JTI: 'TSGC_JTI',
  USER_ACCOUNT: 'TSGC_USER_ACCOUNT',
  PROJECTID: 'TSGC_PROJECTID'
};



// WEBPACK FOOTER //
// ./src/core/constStatic.js